import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Radio,} from 'antd';
// import data
import {databaseList} from "../assets/constants/databases";

const RadioGroup = Radio.Group;
const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
};

class SetDatabase extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      value: props.parameters.database,
    }
  }
  
  onChange = (e) => {
    //console.log('radio checked', e.target.value);

    this.setState({value: e.target.value});
    let _parameters = JSON.parse(JSON.stringify(this.props.parameters));
    _parameters.database = e.target.value;
    
    this.props.updateParameters(_parameters);
  }
  render() {
    // console.log(this.props);
    return (
      <div className="step-outter-wrapper">
        <div className="step-inner-wrapper">
          <div className="step-title-style">
            <h3>Select Database</h3>
          </div>

          <div css={css`
            width: 100%;
            padding: 40px;
          `}>
            <RadioGroup 
              onChange={this.onChange} 
              value={this.state.value}>
              {
                databaseList.map((item, index)=>{
                  return(
                  <Radio style={radioStyle} 
                    key={index} 
                    value={item.value}>{item.label}</Radio>
                  )
                })
              }
            </RadioGroup>
          </div>
        </div>
      </div>
    );
  }
}

export default SetDatabase;